<div class="message-popup">
  <div class="message-popup__modal"></div>
  <div class="message-popup__container">
    <div class="message-popup__title">
      머니 한도 초과 안내
    </div>
    <div class="message-popup__body">
      <div class="message-popup__message">
        <p>한도(<span class="normal-number-text">{{{numberToTextTags moneyLimit}}}</span> 골드)를 초과한 머니는</p>
        {{#if (equal membership 'none')}}
        <p>만료 시간 이후 삭제 됩니다.</p>
        {{/if}}
        {{#if (equal membership 'silverclass')}}
        <p>만료 시간 이후 삭제 됩니다.</p>
        {{/if}}
        {{#if (equal membership 'goldclass')}}
        <p>적립되지 않습니다.</p>
        {{/if}}
      </div>
      <div class="message-popup__box">
        {{#if (equal membership 'silverclass')}}
        <div class="message-popup__box__item"><strong>만료 시간</strong> : <em>{{excessMoneyExpireAt}}</em></div>
        {{/if}}
        {{#if (equal membership 'none')}}
        <div class="message-popup__box__item"><strong>만료 시간</strong> : <em>{{excessMoneyExpireAt}}</em></div>
        {{/if}}
        <div class="message-popup__box__item"><strong>초과 머니</strong> : <em>{{{numberToShortTextTags excessMoney}}} 골드</em></div>
        <div class="message-popup__box__item"><strong>보유 머니</strong> : <b>{{{numberToShortTextTags totalMoney}}} 골드</b></div>
      </div>
      {{#if (equal membership 'none')}}
      <div class="message-popup__notice">
        만료 시간 이전에 클래스 상품을 구매하면 보유 머니를 유지할 수 있습니다.
      </div>
      {{/if}}
      {{#if (equal membership 'silverclass')}}
      <div class="message-popup__notice">
        만료 시간 이전에 골드 클래스 상품을 구매하면 보유 머니를 유지할 수 있습니다.
      </div>
      {{/if}}
    </div>
    <div class="message-popup__footer">
      {{#if (equal membership 'none')}}
      <a data-excess-click="openMallClass" class="message-popup__btn message-popup__btn--important" href="#">클래스 구매</a>
      {{/if}}
      {{#if (equal membership 'silverclass')}}
      <a data-excess-click="openMallClass" class="message-popup__btn message-popup__btn--important" href="#">클래스 구매</a>
      {{/if}}
      <a data-excess-click="confirm" class="message-popup__btn message-popup__btn--cancel" href="#">확인</a>
    </div>
  </div>
</div>